import { render, staticRenderFns } from "./extend.vue?vue&type=template&id=09119cc0"
import script from "./extend.vue?vue&type=script&lang=js"
export * from "./extend.vue?vue&type=script&lang=js"
import style0 from "./extend.vue?vue&type=style&index=0&id=09119cc0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports